<div class="flex flex-row">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <a
      (click)="router.navigateByUrl(breadcrumb.url)"
      [title]="breadcrumb.url"
      class="breadcrumb-link"
    >
      <div class="breadcrumb">
        <mg-icons
          class="w-6 h-6"
          *ngIf="breadcrumb.icon !== ''"
          [name]="breadcrumb.icon ?? ''"
        ></mg-icons>
        <span class="title">{{ breadcrumb.label }}</span>
      </div>
    </a>
    <span *ngIf="!last" class="separator"></span>
  </ng-container>
</div>
